import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const InputText = ({ label, id, type = 'text', invalid, error, className, apiErrors, outterRef, labelClassName,register, info, ...props }) => {
	const { t, i18n } = useTranslation();

	return (
		<>
			<div className={`${className ? className : ''} ${i18n.language === 'ar' && 'rtl-floating'}`}>
				{label && (
					<label htmlFor={id} className={`form-label d-flex ${labelClassName}`}>
						{label}
						{info && <Tooltip title={info}>
							<InfoCircleFilled className='mx-1' />
						</Tooltip>}
					</label>
				)}
				<div className="d-flex">
					<input
						ref={outterRef ?? null}
						type={type}
						className={`form-control ${invalid ? 'is-invalid' : ''}`}
						placeholder={label}
						{...register}
						{...props}
					/>

				</div>
			</div>
			{error && error.message && <div className='invalid-feedback d-block'>{t(error.message)}</div>}
			{apiErrors && apiErrors[props.name] && (
				<div className='invalid-feedback d-block'>
					{apiErrors[props.name]?.map((apiError, index) => {
						return <p key={index}>{apiError}</p>;
					})}
				</div>
			)}
		</>
	);
};

InputText.propTypes = {
	label: PropTypes.string,
	type: PropTypes.string,
	invalid: PropTypes.bool,
	error: PropTypes.object,
	className: PropTypes.string,
	id: PropTypes.string
};
export default InputText;
